<template>
  <div>
    <span v-for="country in countrys" :key="country.code" :class="['country-item', 'ellipsis', {active: active === country.code}]"  @click="() => handleCountryItem(country)">{{country.name}}</span>
  </div>
</template>

<script>


export default {
  props: {
    countrys: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 1
    }
  },
  methods: {
    // 点击每个国家时触发的回调
    handleCountryItem(country) {
      if (this.active === country.code) return
      this.$emit('click', country)
    }
  }
}
</script>

<style lang="scss" scoped>
.country-item {
  display: block;
  height: 62px;
  line-height: 68px;
  text-align: center;
  padding: 0 5px;
  cursor: pointer;
  user-select: none;
  border-bottom: 3px solid #797979;
  transition: border-bottom 0.3s;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.active {
  transition: all 0.3s;
  border-bottom: 3px solid #99c41c !important;
}
</style>